import { render, staticRenderFns } from "./BugReportDialog.vue?vue&type=template&id=8f79a056&"
import script from "./BugReportDialog.vue?vue&type=script&lang=ts&"
export * from "./BugReportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports